function Cart() {
  const $window = $(window);
  const $document = $(document);
  const $body = $('body');
  const $cart = $body.find('div.cart-wrapper');
  const $headerCartQty = $body.find('span.cart-qty');
  const $headerCartQtyLoader = $body.find('span.cart-qty-loader');

  const template = $('[data-id="widget-cart-template"]').text() ?? '';

  const init = async () => {
    template && window.aguadecoco.helpers.mustache.parse(template);

    bindHtmlTriggers();
    render(true);

    $window.on(
      'orderFormUpdated.vtex',
      debounce(() => render(), 200),
    );
    $window.on('checkoutRequestBegin.vtex', showLoader);
    $window.on('checkoutRequestEnd.vtex', hideLoader);

    getRemoteOrderForm();
  };

  const updateQntInHeader = async (itemsQnt: number) => {
    if ($headerCartQty.length === 0) {
      return;
    }

    $headerCartQty.text(itemsQnt);

    if (itemsQnt) {
      $headerCartQty.addClass('active');
      return;
    }

    $headerCartQty.removeClass('active');
  };

  const closeCart = () => {
    $body.removeClass('offcanvas-cart-opened');
    $cart.removeClass('cart-opened');
  };

  const openCart = () => {
    $body.addClass('offcanvas-cart-opened');
    $cart.addClass('cart-opened');
  };

  const showLoader = () => {
    $cart.addClass('cart-loading');
    $headerCartQtyLoader.addClass('active');
  };

  const hideLoader = () => {
    $cart.removeClass('cart-loading');
    $headerCartQtyLoader.removeClass('active');
  };

  const debounce = (fn: () => void, time: number) => window.aguadecoco.helpers.debounce(fn, time);

  const money = (value: number, showFreeString = false) =>
    window.aguadecoco.helpers.format.money(value, showFreeString);

  const getRemoteOrderForm = async (forceUpdate = false): Promise<OrderFormData | null> => {
    let data = {} as OrderFormData | null;
    if (forceUpdate) {
      data = vtexjs.checkout.getOrderForm();
    } else {
      data = window.vtexjs?.checkout?.orderForm || vtexjs.checkout.getOrderForm();
    }

    if (data?.messages?.length === 1) {
      if (data?.messages[0]?.code === 'changedFreightPrice' || data?.messages[0]?.code === 'changedFreight') {
        clearMessages();
        data.messages = [];
      }
      if (data?.messages[0]?.code === 'couponNotFound') {
        clearMessages(true);
      }
    }

    return data;
  };

  const getCheckout = () => window.vtexjs.checkout;

  const clearMessages = async (onlyRemote = false) => {
    await window.vtexjs.checkout.clearMessages();
    if (onlyRemote) {
      return;
    }
    $cart.find('.cart-messages').remove();
  };

  async function removeItem(uniqueId: number, index: number) {
    await vtexjs.checkout.removeItems([{ index, uniqueId }]);
  }

  function bindHtmlTriggers() {}

  function onDeleteItemClick(event) {
    event.preventDefault();
    const $item = $(event.currentTarget).closest('.cart-item');
    const id = $item.data('id');
    const index = $item.data('index');

    removeItem(id, index);
  }

  async function updateItem(item) {
    const checkout = getCheckout();
    await checkout.updateItems([item], null, false);
  }

  async function onAddMoreItemClick(event) {
    event.preventDefault();
    const oderForm = await getRemoteOrderForm();
    const $item = $(event.currentTarget).closest('.cart-item');
    const id = $item.data('item-id');
    const index = $item.data('index');
    const quantity = oderForm?.items?.find((item) => String(item.id) === String(id))?.quantity || 1;

    await updateItem({ index, quantity: Number(quantity) + 1 });
  }

  async function onLessItemClick(event) {
    event.preventDefault();
    const oderForm = await getRemoteOrderForm();
    const $item = $(event.currentTarget).closest('.cart-item');
    const id = $item.data('item-id');
    const index = $item.data('index');
    const quantity = oderForm?.items?.find((item) => String(item.id) === String(id))?.quantity || 1;

    if (Number(quantity) <= 1) return;

    await updateItem({ index, quantity: Number(quantity) - 1 });
  }

  function bindHtmlDynamicTriggers() {
    $cart.find('.cart-footer-form-shipping').on('submit', setPostalCode);
    $cart.find('.cart-footer-form-shipping .remove').on('click', _removePostalCode);

    $cart.find('.cart-footer-form-cupom').on('submit', addCupomCode);
    $cart.find('.cart-footer-form-cupom .remove').on('click', removeCupom);

    $cart.find('.cart-footer-form-seller').on('submit', addSellerCode);
    $cart.find('.cart-footer-form-seller .remove').on('click', _removeSellerCode);

    $cart.find('.cart-btn-more').on('click', onAddMoreItemClick);
    $cart.find('.cart-btn-less').on('click', onLessItemClick);
    $cart.find('.cart-item-remove').on('click', onDeleteItemClick);
    $cart.find('.cart-message').on('click', () => clearMessages());

    const cepInput = document.querySelector('#cart-cep');
    if (cepInput) {
      new window.aguadecoco.helpers.Mask(cepInput);
      cepInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  async function _removePostalCode() {
    window.vtexjs?.checkout?.sendAttachment('shippingData', {});
  }

  async function setPostalCode(event) {
    event.preventDefault();
    const formData = new FormData(event.currentTarget as HTMLFormElement);
    const postalCode = formData.get('cep');
    if (!postalCode) {
      _removePostalCode();
      return;
    }
    const data = await (await fetch(`/api/checkout/pub/postal-code/BRA/${postalCode}`)).json();
    if (data?.city) {
      getCheckout().calculateShipping({ country: 'BRA', postalCode: postalCode.toString().replace(/\D/g, '') });
    } else {
      vtexjs.checkout.orderForm.messages = [
        {
          status: 'error',
          code: 'postal-code',
          text: 'CEP inválido',
        },
      ];
      render();
    }
  }

  async function addCupomCode(event: Event) {
    event.preventDefault();

    const formData = new FormData(event.currentTarget as HTMLFormElement);
    const cupom = formData.get('cupom');
    if (!cupom) return;

    const checkout = getCheckout();
    const response = await checkout.addDiscountCoupon(cupom);

    const messages = (response?.messages || []).length;

    if (messages) {
      // TODO: erro no cupom
    }

    console.log('cupom', response);
  }

  function removeCupom() {
    return vtexjs.checkout.removeDiscountCoupon();
  }

  async function _removeSellerCode() {
    await vtexjs.checkout.sendAttachment('marketingData', {
      utmiCampaign: 'semcodigo',
      utmiPart: '',
    });
    await vtexjs.checkout.sendAttachment('openTextField', {
      value: '',
    });
  }

  async function addSellerCode(event: Event) {
    event.preventDefault();
    // TODO : implementar cache

    const formData = new FormData(event.currentTarget as HTMLFormElement);
    const code = formData.get('seller-code');
    if (!code) {
      _removeSellerCode();
      return;
    }

    const response = await (
      await fetch(`/api/dataentities/VD/search?codigo=${code}&_fields=id,codigo,Nome,status`)
    ).json();

    if (response.length === 0) {
      vtexjs.checkout.orderForm.messages = [
        {
          status: 'error',
          code: 'seller-code',
          text: 'Código de vendedora inválido.',
        },
      ];
      render();
      return;
    }

    const checkout = getCheckout();

    await checkout.sendAttachment('marketingData', {
      utmiCampaign: 'codigovendedor',
      utmiPart: code,
    });

    await checkout.sendAttachment('openTextField', {
      value: `${response[0].codigo} - ${response[0].Nome}`,
    });
  }

  function getBestInstallmentValue(orderForm) {
    const installmentOptions = orderForm?.paymentData?.installmentOptions;
    if (!installmentOptions || !installmentOptions.length) {
      return null;
    }
    const installments = installmentOptions
      .map((installments2) => {
        const options = installments2.installments
          .filter(({ hasInterestRate }) => !hasInterestRate)
          .sort((a, b) => a.count - b.count)
          .reverse();

        if (!options.length) {
          return null;
        }

        return {
          ...options[0],
          paymentSystem: installments2.paymentSystem,
        };
      })
      .filter((item) => !!item)
      .sort((a, b) => a.count - b.count)
      .reverse();

    if (installments.length === 0) {
      return null;
    }

    const selected = installments[0];
    const method = orderForm.paymentData.paymentSystems.find(
      (paymentSystem) => paymentSystem.id === selected.paymentSystem,
    );

    return {
      ...selected,
      valueFormated: money(selected.value / 100),
      paymentSystemName: method?.name,
      groupName: method?.groupName,
    };
  }

  async function render(firstLoader = false) {
    if (firstLoader) {
      showLoader();
    }
    const orderForm = firstLoader === true ? ({} as any) : await getRemoteOrderForm();
    const installments = getBestInstallmentValue(orderForm);
    const itemsCount = orderForm?.items?.length ?? 0;
    const totalizers = orderForm?.totalizers;
    updateQntInHeader(itemsCount);

    const subtotal = totalizers?.find((items) => items.id === 'Items')?.value / 100 || 0;
    const discounts = totalizers?.find((items) => items.id === 'Discounts')?.value / 100 || 0;
    const shipping = totalizers?.find((items) => items.id === 'Shipping')?.value / 100 || 0;

    const total = subtotal + discounts;

    const subtotalFormated = money(subtotal);
    const discountsFormated = money(discounts);
    const totalFormated = money(total);

    const skus = orderForm?.items?.map(({ id }) => id) ?? [];

    const details = skus?.length ? await window.aguadecoco.helpers.getSkuInfoByProductList(skus, 'productId') : {};

    const coupon = orderForm?.marketingData?.coupon ?? '';
    const sellerCode = orderForm?.marketingData?.utmiPart ?? '';
    showLoader();

    const products = orderForm?.items?.map((item, index) => ({
      index,
      name: details?.[item.id]?.productName,
      ImageAlt: `${item.name}`,
      // imageUrl: (details?.[item.id]?.imagensUrl || [item])?.[0]?.imageUrl,
      imageUrl: item.imageUrl,
      detailUrl: item.detailUrl,
      size: details?.[item.id]?.sizeFormated,
      quantity: item.quantity,
      olPrice: item.listPrice > item.sellingPrice ? money(item.listPrice / 100) : false,
      price: money(item.sellingPrice / 100),
      showLine: orderForm?.items.length > 1,
      id: item.uniqueId,
      itemId: item.id,
      disabledBtnLess: Number(item.quantity) === 1,
    }));

    const sla = orderForm?.shippingData?.logisticsInfo?.[0]?.sla?.find(
      (sla) => sla.id === orderForm?.shippingData?.logisticsInfo[0]?.selectedSla,
    );
    const shippingData = {
      id: orderForm?.shippingData?.logisticsInfo[0]?.selectedSla,
      postalCode: orderForm?.shippingData?.selectedAddresses[0]?.postalCode ?? '',
      selectedSla: orderForm?.shippingData?.logisticsInfo[0]?.selectedSla,
      sla,
      price: money(shipping, true),
    };

    const freeShippingGoal = parseInt($document.find('.freeshipping-value').text());

    const percentProgressShipping = (100 / freeShippingGoal) * subtotal;

    const html = window.aguadecoco.helpers.mustache.render(template, {
      messages: orderForm.messages || [],
      installments,
      firstLoader,
      itemsLength: itemsCount,
      products,
      totalFormated,
      subtotalFormated,
      hasDiscounts: discounts !== 0,
      discountsFormated,
      shippingFortmated: shippingData?.id ? shippingData?.price : '-',
      coupon,
      hasShippingData: shippingData?.id,
      shippingData,
      sellerCode,
      freeShipping: percentProgressShipping >= 100,
      percentProgressShipping: Math.min(100, percentProgressShipping) + '%',
      freeShippingGoalRest: money(freeShippingGoal - subtotal),
    });

    $cart.html(html);

    bindHtmlDynamicTriggers();
    if (!firstLoader) {
      hideLoader();
    }
  }

  init();
  $document.on('widgetRightCartOpen', openCart);
  $document.on('widgetRightCartClose', closeCart);
  $document.on('keydown', function (event) {
    if (event.key === 'Escape') {
      $document.trigger('widgetRightCartClose');
    }
  });
}

window.aguadecoco = window.aguadecoco || {};
Object.assign(window.aguadecoco, {
  widgets: Object.assign(window.aguadecoco.widgets || {}, { cart: new Cart() }),
});

export default {};
